import { COOKIE_TAG } from "shared/constants";
import { Cookie } from "shared/utils";

const getAccessToken = async (): Promise<string | undefined> => {
  const cookie = Cookie.get(COOKIE_TAG);
  return cookie?.user?.accessToken ?? undefined;
};

export default getAccessToken;
